import { Component, OnInit, Injector } from '@angular/core';
import { ChallengesComponent } from '../challenges/challenges.component';
import { Tournament } from '../../api/DixApiClient';

@Component({
  selector: 'app-mobile-challenges',
  template: require('./mobile-challenges.component.html'),
  styles: [require('./mobile-challenges.component.scss')]
})
export class MobileChallengesComponent extends ChallengesComponent implements OnInit {

  constructor(  injector: Injector) {
    super(injector)
    //console.log("AQQ");
   }

  ngOnInit() {
   // console.log("AQQ1");
  }

  ngAfterViewInit()
  {
  }

  public get currentTournaments (): Tournament[] {
    return this.workspace.currentTournaments;
  }

  public set currentTournaments ( value: Tournament[] ) {
    this._currentTournaments = value;
  }

  public get upcomingTournaments (): Tournament[] {
    return this.workspace.upcomingTournaments;
  }

  public set upcomingTournaments ( value: Tournament[] ) {
    this._upcomingTournaments = value;
  }

  public get lastTournaments (): Tournament[] {
    return this.workspace.lastTournaments;
  }

  public set lastTournaments ( value: Tournament[] ) {
    this._lastTournaments = value;
  }
}
